import * as adob from '../../utils/analytics/adobe/adob';
import { useTranslation } from 'react-i18next';
import queryString from 'query-string';
import pushToGTM, { redirectToProductPageTagGA4 } from '../../utils/analytics/gtm';
import Link from '../Link';

export function RenderChatbotLink({ productPageLink, fullURL, path, domain }) {
	const { t } = useTranslation(['main', 'category']);
	const partNumber = new URL(productPageLink).searchParams.get('id');
	const trackingParameters = {
		redirectLink: productPageLink,
		partNumber: partNumber,
		buttonName: t('main:components.chatbot.productPage'),
		segment: adob.segment,
		fullURL: fullURL,
		path: path,
		breadcrumbs: adob.breadcrumbs,
		logEventType: adob.logEventType.PRODUCTLOG
	};
	const redirectLink =
		'https://www.' +
		domain +
		'/design/tools-software/product-recommendation-tools-plus/linksRedirect?' +
		queryString.stringify(trackingParameters);
	return (
		<Link
			href={redirectLink}
			color={'primary'}
			target="_blank"
			onClick={() => {
				pushToGTM(redirectToProductPageTagGA4());
			}}>
			{t('main:components.chatbot.productPage')}
		</Link>
	);
}
